import { resolveHttpErrorViewState } from '@/features/api/services/utils/resolveHttpErrorViewState.js'
import {
  REGISTER_ALREADY_REGISTERED,
  REGISTER_FAILURE_PREFIX,
  extractRegisterFailureDetail,
} from '@/features/auth/utils/parseWebRegisterResponse.js'

const REGISTER_ERROR_I18N_KEYS = {
  Email_Already_Exists: 'register.emailAlreadyExists',
  [REGISTER_ALREADY_REGISTERED]: 'register.emailAlreadyExists',
}

const REGISTER_FAILURE_DETAIL_I18N_KEYS = [
  {
    pattern: /non.?alphanumeric/i,
    i18nKey: 'register.passwordMissingSpecialCharacter',
  },
  {
    pattern: /digit|number|numeric/i,
    i18nKey: 'register.passwordMissingNumber',
  },
  {
    pattern: /uppercase|upper.?case/i,
    i18nKey: 'register.passwordMissingUppercase',
  },
  {
    pattern: /lowercase|lower.?case/i,
    i18nKey: 'register.passwordMissingLowercase',
  },
  {
    pattern: /at least \d+|too short|length/i,
    i18nKey: 'register.passwordTooShort',
  },
]

function resolveHttpStatusI18nKey(error) {
  if (!error || typeof error !== 'object') {
    return null
  }

  const { messageKey, status } = resolveHttpErrorViewState(error)

  if (typeof status !== 'number' || !messageKey) {
    return null
  }

  return messageKey
}

export function getAuthApiErrorCode(error) {
  const data = error?.response?.data

  if (typeof data === 'string') {
    return data
  }

  if (typeof data?.value === 'string') {
    return data.value
  }

  return null
}

export function resolveRegisterFailureResponseI18nKey(rawResponse) {
  if (typeof rawResponse !== 'string' || !rawResponse.startsWith(REGISTER_FAILURE_PREFIX)) {
    return 'register.registerError'
  }

  const detail = extractRegisterFailureDetail(rawResponse)

  if (!detail) {
    return 'register.registerError'
  }

  const normalizedDetail = detail.toLowerCase()

  for (const rule of REGISTER_FAILURE_DETAIL_I18N_KEYS) {
    if (rule.pattern.test(normalizedDetail)) {
      return rule.i18nKey
    }
  }

  return 'register.registerError'
}

export function resolveRegisterApiErrorI18nKey(errorOrCode) {
  if (typeof errorOrCode === 'string') {
    if (!errorOrCode) {
      return 'register.registerError'
    }

    return REGISTER_ERROR_I18N_KEYS[errorOrCode] || 'register.registerError'
  }

  const code = getAuthApiErrorCode(errorOrCode)

  if (code) {
    return REGISTER_ERROR_I18N_KEYS[code] || 'register.registerError'
  }

  return resolveHttpStatusI18nKey(errorOrCode) || 'register.registerError'
}

export function isRegisterEmailAlreadyExistsError(errorOrCode) {
  const code = typeof errorOrCode === 'string' ? errorOrCode : getAuthApiErrorCode(errorOrCode)

  return code === 'Email_Already_Exists' || code === REGISTER_ALREADY_REGISTERED
}
